module.exports = __webpack_public_path__ + "img/Rectangle-3.5c3f0be9.png";